export default "__VITE_ASSET__DEbeC7UV__"